export class MachineModel {
    Id: number;
    machine_manufacturer_id: number;
    name: string;
    is_active: boolean;
    is_bandsaw: boolean;
}